<template>
  <div class="openOrder_order">
    <div class="backBox">
      <span class="tBack" @click="toBack">
        <van-icon name="arrow-left" />
      </span>
    </div>
    <!-- 添加 -->
    <div class="order_add_box" @click="toBuyerList">
      <div class="order_name">添加订单</div>
    </div>
    <!-- 批次列表 -->
    <div class="order_list">
      <!-- 已添加的 -->
      <van-tabs
        ref="ref_tab_order"
        v-model="order_active_index"
        line-height="0"
        :border="false"
        color="transparent"
        background="transparent"
        @change="changeOrder"
      >
        <van-tab v-for="(item,index) in order_list" :key="index" :name="index">
          <template #title>
            <!-- <div class="order_name van-ellipsis">{{item.no}}</div> -->
            <div class="order_name van-ellipsis">{{item.buyer_name}}</div>
          </template>
        </van-tab>
      </van-tabs>
    </div>

    <!-- 订单里的商品 -->
    <div class="all_shop_box" v-if="order_list.length>0">
      <!-- 单个购物车 -->
      <!-- {{order_list}} -->
      <div
        class="item_shop_box"
        v-for="(item_box,index_box) in order_list"
        :key="index_box"
        v-show="index_box == order_active_index"
      >
        <!-- 购物车box -->
        <div class="shop_box">
          <div
            class="shop_good checked"
            v-for="(item_good,index_good) in item_box.order_goods"
            :key="index_good"
            @click="changeNum(index_box,index_good,item_good)"
          >
            <!-- 商品名字和金额 -->
            <div v-if="item_good.goods_type == 1">
              <div class="shop_good_name_price">
                <div class>{{item_good.name}}</div>
                <div v-if="item_good.bale == 1">￥{{(Math.round(item_good.price * item_good.num * 100)/100).toFixed(2)}}</div>
                <div v-else>￥{{(Math.round(item_good.price * item_good.weight * 100)/100).toFixed(2)}}</div>
              </div>
              <!-- 商品规格和数量 -->
              <div class="shop_good_type_num">
                <div class>
                  <div class="good_type good_type_0" v-if="item_good.bale == 3">
                    散装
                    <img src="./../../../assets/img/work/open_order/order/type_sanzhuang.png" alt />
                  </div>
                  <div class="good_type good_type_1" v-if="item_good.bale == 1">
                    定装
                    <img
                      src="./../../../assets/img/work/open_order/order/type_dingzhuang.png"
                      alt
                    />
                  </div>
                  <div class="good_type good_type_2" v-if="item_good.bale == 2">
                    非定装
                    <img
                      src="./../../../assets/img/work/open_order/order/type_feidingzhuang.png"
                      alt
                    />
                  </div>
                </div>
                <div
                  v-if="item_good.bale == 1"
                >{{item_good.num}}{{unit_list[item_good.num_unit-1].name}}x{{Number(item_good.price).toFixed(2)}}元/{{unit_list[item_good.num_unit-1].name}}</div>
                <div
                  v-else
                >{{Number(item_good.weight)*1}}公斤x{{Number(item_good.price).toFixed(2)}}元/公斤</div>
              </div>
            </div>
            <!-- 附加费 -->
            <div v-else>
              <div class="shop_good_name_price">
                <div class>{{item_good.name}}</div>
                <div>￥{{(Math.round(item_good.price * item_good.num * 100)/100).toFixed(2)}}</div>
              </div>
              <!-- 商品规格和数量 -->
              <div class="shop_good_type_num">
                <div class>
                  <div class="good_type good_type_3">
                    附加费
                    <img src="./../../../assets/img/work/open_order/order/type_fujiafei.png" alt />
                  </div>
                </div>
                <div>{{item_good.price}}{{item_good.type == 1?'元/个':'元'}} {{item_good.type == 1?" x "+(item_good.num-0)+'个':''}}</div>
              </div>
            </div>
            <div class="shop_good_close" @click.stop="clearGoods(index_box,index_good)">
              <van-icon name="cross" size="0.24rem" />
            </div>
          </div>
        </div>
        <div  class="iRemark" v-if="order_list[order_active_index].desc!=''&& order_list[order_active_index].desc!=null">备注：{{order_list[order_active_index].desc}}</div>
        <!-- 添加货品 -->
        <div class="add_shop_good" @click="addGoods">
          <van-icon name="plus" size="0.36rem" />
          <span style="margin-left:0.1rem">添加商品</span>
        </div>
        <!-- 删除该订单 -->
        <div class="romove_shop" @click="removeOrder(index_box)">
          <!-- 
          v-if="!(order_list.length == 1&& order_list[0].order_goods.length == 0)"-->
          <van-icon name="delete" size="0.36rem" />
          <span style="margin-left:0.1rem">删除该订单</span>
        </div>
      </div>
    </div>

    <!-- 没有订单的话显示添加订单 -->
    <div class="all_shop_box" v-if="order_list.length == 0">
      <!-- 添加订单 -->
      <div style="height:0.8rem"></div>
      <div class="add_shop_good" @click="toBuyerList">
        <van-icon name="plus" size="0.36rem" />
        <span style="margin-left:0.1rem">添加订单</span>
      </div>
    </div>

    <!-- 底部结算栏 -->
    <div style="height:1.4rem"></div>
    <div v-if="order_list.length>0" class="order_footer" :disabled="total_goods_num==0">
      <div>
        <span>
          总计：
          <span class="color_theme">￥{{total_goods_amount}}</span>
        </span>
        <span>
          已选：
          <span class="color_theme">{{total_goods_num}}</span> 种
        </span>
      </div>
      <div class="operation">
        <div class="remark" @click="toRemark">备注</div>
        <div class="toConfirm" @click="onSubmit">开单</div>
      </div>
    </div>

    <van-action-sheet
      v-model="showGoodsNum"
      :close-on-click-overlay="false"
      @closed="keyOnClose"
      @open="resetKey = true"
    >
      <div class="good_num_box" id="good_num_box" v-if="resetKey">
        <div class="good_title_box">
          {{input_active_goods.name}}
          <span v-if="input_active_goods.bale == 1">定装</span>
          <span v-if="input_active_goods.bale == 2">非定装</span>
          <span v-if="input_active_goods.bale == 3">散装</span>
          <span v-if="input_active_goods.goods_type == 2">附加费</span>
          <div class="good_box_close" @click="showGoodsNum = false">
            <van-icon name="cross" size="0.4rem" />
          </div>
        </div>
        <div class="good_content_box">
          <div class="good_item_wn" v-if="input_active_goods.goods_type == 1">
            <!-- 规格 -->
            <!-- <div class="good_item_input_box" v-if="input_active_goods.bale == 1">
              <KeyBoardInput :k_default_show="input_active_goods.bale == 1" :k_default_div="true" k_appendToId="good_num_box" v-model="keyData.bale_num" :k_placeholder="input_active_goods.bale_num" :k_decimal="3">
                <template slot="input_left">
                  <div class="input_left">规格</div>
                </template>
                <template slot="input_right">
                  <div class="input_right">公斤/{{unit_list[input_active_goods.num_unit-1].name}}</div>
                </template>
              </KeyBoardInput>
            </div>-->
            <!-- 数量 -->
            <div
              class="good_item_input_box"
              v-if="input_active_goods.bale == 1 || input_active_goods.bale == 2"
            >
              <KeyBoardInput
                :k_default_show="input_active_goods.bale == 2 || input_active_goods.bale == 1"
                :k_default_div="true"
                k_appendToId="good_num_box"
                v-model="keyData.num"
                :k_placeholder="Number(input_active_goods.num)"
                :k_decimal="2"
              >
                <template slot="input_left">
                  <div class="input_left">数量</div>
                </template>
                <template slot="input_right">
                  <div class="input_right">{{unit_list[input_active_goods.num_unit-1].name}}</div>
                </template>
              </KeyBoardInput>
            </div>
            <!-- 重量 -->
            <div
              class="good_item_input_box"
              v-if="input_active_goods.bale == 2 || input_active_goods.bale == 3"
            >
              <KeyBoardInput
                :k_default_show="input_active_goods.bale == 3"
                :k_default_div="true"
                k_appendToId="good_num_box"
                v-model="keyData.weight"
                :k_placeholder="input_active_goods.weight"
                :k_decimal="3"
              >
                <template slot="input_left">
                  <div class="input_left">重量</div>
                </template>
                <template slot="input_right">
                  <div class="input_right">公斤</div>
                </template>
              </KeyBoardInput>
            </div>
            <!-- 单价 -->
            <div class="good_item_input_box">
              <KeyBoardInput
                :k_default_show="false"
                :k_default_div="true"
                k_appendToId="good_num_box"
                v-model="keyData.price"
                :k_placeholder="input_active_goods.price"
                :k_decimal="2"
              >
                <template slot="input_left">
                  <div class="input_left">单价</div>
                </template>
                <template slot="input_right">
                  <div class="input_right">
                    <div
                      v-if="input_active_goods.bale == 1"
                    >元/{{unit_list[input_active_goods.num_unit-1].name}}</div>
                    <div v-if="input_active_goods.bale == 4">元/个</div>
                    <div v-if="input_active_goods.bale == 2 || input_active_goods.bale == 3">元/公斤</div>
                  </div>
                </template>
              </KeyBoardInput>
            </div>
          </div>
          <div class="good_item_wn" v-else>
            <div class="good_item_input_box" v-if="input_active_goods.type == 1">
              <KeyBoardInput
                :k_default_show="true"
                :k_default_div="true"
                k_appendToId="good_num_box"
                v-model="keyData.num"
                :k_placeholder="Number(input_active_goods.num)"
                :k_decimal="2"
              >
                <template slot="input_left">
                  <div class="input_left">数量</div>
                </template>
                <template slot="input_right">
                  <div class="input_right">个</div>
                </template>
              </KeyBoardInput>
            </div>
            <div class="good_item_input_box" v-if="input_active_goods.type == 1">
              <KeyBoardInput
                :k_default_show="false"
                :k_default_div="true"
                k_appendToId="good_num_box"
                v-model="keyData.price"
                :k_placeholder="input_active_goods.price"
                :k_decimal="2"
                :k_isNegative="input_active_goods.price<0"
              >
                <template slot="input_left">
                  <div class="input_left">单价</div>
                </template>
                <template slot="input_right">
                  <div class="input_right">元/个</div>
                </template>
              </KeyBoardInput>
            </div>
            <div class="good_item_input_box" v-if="input_active_goods.type != 1">
              <KeyBoardInput
                :k_default_show="true"
                :k_default_div="true"
                k_appendToId="good_num_box"
                v-model="keyData.price"
                :k_placeholder="input_active_goods.price"
                :k_isNegative="input_active_goods.price<0"
                :k_decimal="2"
              >
                <template slot="input_left">
                  <div class="input_left">金额</div>
                </template>
                <template slot="input_right">
                  <div class="input_right">元</div>
                </template>
              </KeyBoardInput>
            </div>
          </div>
        </div>
        <!-- 使用一个假的键盘占个位置 -->
        <div class="fake_div">
          <div class="fake_confim">
            <button type="button" class="van-key van-key--large" @touchstart="keyOnConfirm">完成</button>
          </div>
          <div class="van-key__wrapper"></div>
          <van-number-keyboard
            style="position: relative;"
            :show="true"
            :transition="false"
            :extra-key="['AC','.']"
            close-button-text="完成"
            theme="custom"
            z-index="1"
          ></van-number-keyboard>
        </div>
      </div>
    </van-action-sheet>
    <div class="mask" v-if="showRemark" @click="showRemark = false">
      <div class="content" @click.stop>
        <div class="toBox">
          <span>备注:</span>
          <input type="text" placeholder="请输入需要备注的信息" v-model="remarkTips" :focus="focus"/>
        </div>
        <div class="maskConfirm">
          <Button @click="showRemark = false,remarkTips=''">取消</Button>
          <Button @click="getRemark">确定</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import KeyBoardInput from "@/components/KeyBoardInput";
import {
  shopCar_list,
  shopCar_one,
  shopCar_update,
  shopCar_delete,
  shopCarCheckOut_submit,
  order_desc
} from "@/api/work/order/openOrder";
import Cookies from "@/utils/Cookies";
export default {
  name: "openOrder_order",
  components: {
    KeyBoardInput
  },
  data() {
    return {
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" }
      ],
      order_active_index: 0,
      order_list: [],

      total_goods_num: 0,
      total_goods_amount: 0.0,

      /**
       * 数字键盘功能
       */
      // 显示规格调整
      input_active_order_index: "",
      input_active_goods_index: "",
      input_active_goods: "",
      showGoodsNum: false,
      keyData: {
        weight: "",
        num: "",
        price: ""
      },
      resetKey: true,
      showRemark: false, //控制备注弹框
      remarkTips: "",//备注信息
      focus:false
    };
  },
  created() {
    // 获取已经添加的列表
    this.getOrderList();
    this.computeTotal();
    // 初始化回调监听
    this.$navigation.on("back", (to, from) => {
      if (to.route.name == "openOrder_order") {
        // 结账
        if (from.route.name == "openOrder_orderPay") {
          this.getOrderList();
          this.computeTotal();
        }
        // 选择商品
        if (
          from.route.name == "openOrder_changeGoods" ||
          from.route.name == "openOrder_selectBatch"
        ) {
          if (from.route.meta.backData) {
            console.log(this.order_list[this.order_active_index].order_goods)
            console.log(this.order_list[this.order_active_index])
            this.order_list[this.order_active_index].order_goods.push(
              JSON.parse(from.route.meta.backData)
            );
            this.saveOrderGoods(this.order_active_index);
          }
        }
        // 添加订单
        if (
          from.route.name == "manage_buyer_buyerManage" &&
          from.route.meta.backData
        ) {
          var data = JSON.parse(JSON.stringify(from.route.meta.backData));
          this.addOrder(data);
        }
        this.computeTotal();
      }
    });
  },
  mounted() {},
  methods: {
    // 切换批次
    changeOrder(i) {
      this.computeTotal();
    },
    //
    toBack(){
       this.$router.replace({
        path: "/home"
      });
    },
    // 去选择买家
    toBuyerList() {
      this.$router.push({
        path: "/manage/buyer/buyerManage",
        query: {
          use_type: 1
        }
      });
    },
    // 添加一个订单
    addOrder(buyer_info) {
      var subData = {
        buyer_id: buyer_info.id,
        buyer_name: buyer_info.name
      };
      shopCar_one(subData).then(res => {
        if (res.code == 200) {
          this.addGoods();
          this.getOrderList();
        }
      });
      this.order_active_index = 0;
      this.computeTotal();
    },
    // 获取订单列表
    getOrderList() {
      shopCar_list().then(res => {
        if (res.code == 200) {
          var list = [];
          for (let i = 0; i < res.data.length; i++) {
            const item = res.data[i];
            item.order_goods = item.goods;
            list.push({
              id: item.id,
              no: item.no,
              buyer_id: item.buyer_id,
              buyer_name: item.buyer_name,
              goods: "",
              order_goods: item.goods,
              date: item.date,
              desc:item.desc
            });
          }
          this.order_list = [...list];
          this.computeTotal();
        }
      });
    },

    // 保存订单信息
    saveOrderGoods(i) {
      let order_data = {
        id: this.order_list[i].id,
        goods: JSON.stringify(this.order_list[i].order_goods)
      };
      shopCar_update(order_data).then(res => {
        if (res.code == 200) {
          this.getOrderList();
        }
      });
    },
    //备注
    getRemark() {
      console.log(this.remarkTips);
      let item = this.order_list[this.order_active_index];
      let obj={
        id:item.id,
        desc:this.remarkTips
      }
      order_desc(obj).then(res=>{
        if(res.code==200){
          this.$toast.success("提交成功");
          this.getOrderList();
          this.showRemark = false;
          this.remarkTips=""
        }
      })
      
      
    },
    toRemark(){

      if(this.total_goods_num>0){
        this.showRemark=true
      }else{
        this.$toast.fail("请先添加商品");
      }
      this.$nextTick(()=>{
        this.focus = true
      })
    },
    // 结账
    onSubmit() {
      this.computeTotal();
      let item = this.order_list[this.order_active_index];
      if (JSON.stringify(item.order_goods).length == 0) {
        return false;
      }
      var subData = {
        gid: item.id,
        buyer_id: item.buyer_id,
        goods: JSON.stringify(item.order_goods),
        desc:item.desc?item.desc:""
      };
      if (this.total_goods_num > 0) {
        shopCarCheckOut_submit(subData).then(res => {
          if (res.code == 200) {
            this.$toast.success("提交成功");
            this.getOrderList();
          }
        });
      } else {
        this.$toast.fail("请先添加商品");
      }
    },

    // 计算总价
    computeTotal() {
      if (this.order_list.length > 0) {
        this.order_active_index =
          this.order_active_index > this.order_list.length - 1
            ? 0
            : this.order_active_index;
        var goods = this.order_list[this.order_active_index].order_goods;
        var amount = 0;
        for (let i = 0; i < goods.length; i++) {
          const item = goods[i];
          if (item.goods_type == 1) {
            if (item.bale == 1) {
              amount += Math.round(item.price * item.num *100)/100;
            } else {
              amount += Math.round(item.price * item.weight * 100)/100;
            }
          } else if (item.goods_type == 2) {
            amount += Math.round(item.price * item.num * 100)/100;
          }
        }
        this.total_goods_num = goods.length;
        this.total_goods_amount = amount.toFixed(2);
      }
    },

    // 删除一件商品
    clearGoods(i, i_g) {
      var name =
        this.order_list[i].order_goods[i_g].goods_type == 1
          ? "商品 "
          : "附加费 ";
      this.$dialog
        .confirm({
          title: "删除" + name,
          message:
            "确认删除" +
            name +
            this.order_list[i].order_goods[i_g].name +
            "吗？"
        })
        .then(() => {
          this.order_list[i].order_goods.splice(i_g, 1);
          this.saveOrderGoods(i);
          this.computeTotal();
        })
        .catch(() => {
          // on cancel
        });
    },

    // 删除一个订单
    removeOrder(i) {
      if (this.order_list[i].order_goods.length > 0) {
        this.$dialog
          .confirm({
            title: "删除订单",
            message: "该订单内还有商品未结算，确认删除吗？"
          })
          .then(() => {
            shopCar_delete({ id: this.order_list[i].id, status: -1 }).then(
              res => {
                if (res.code == 200) {
                  this.order_list.splice(i, 1);
                }
                this.computeTotal();
              }
            );
            
          })
          .catch(() => {
            // on cancel
          });
      } else {
        shopCar_delete({ id: this.order_list[i].id, status: -1 }).then(res => {
          if (res.code == 200) {
            this.order_list.splice(i, 1);
              this.computeTotal();
          }
        });
      }
    },
    // 去选择商品
    addGoods() {
      this.$router.push({
        path: "/openOrder/selectBatch"
      });
    },

    /**
     * 修改规格相关
     */
    changeNum(i, i_g, good) {
      this.input_active_order_index = i;
      this.input_active_goods_index = i_g;
      this.input_active_goods = JSON.parse(JSON.stringify(good));
      // this.keyData.weight = good.weight +''
      // this.keyData.bale_num = good.bale_num +''
      // this.keyData.num = good.num +''
      // this.keyData.price = good.price +''
      this.showGoodsNum = true;
    },
    // 完成
    keyOnConfirm() {
      var good = this.input_active_goods;
      this.keyData.weight =
        this.keyData.weight === "" ? good.weight + "" : this.keyData.weight;
      // this.keyData.bale_num = this.keyData.bale_num===""?good.bale_num +'':this.keyData.bale_num
      this.keyData.num =
        Number(this.keyData.num === "" ? good.num + "" : this.keyData.num) + "";
      this.keyData.price =
        this.keyData.price === "" ? good.price + "" : this.keyData.price;

      // if(this.input_active_goods.bale == 1 && !(this.keyData.bale_num>0)){ this.$toast("请输入商品规格！"); return false }
      if (this.input_active_goods.bale == 1 && !(this.keyData.num > 0)) {
        this.$toast("请输入商品销售数量！");
        return false;
      }
      if (this.input_active_goods.bale == 2 && !(this.keyData.num > 0)) {
        this.$toast("请输入商品销售数量！");
        return false;
      }
      if (this.input_active_goods.bale == 2 && !(this.keyData.weight > 0)) {
        this.$toast("请输入商品销售重量！");
        return false;
      }
      if (this.input_active_goods.bale == 3 && !(this.keyData.weight > 0)) {
        this.$toast("请输入商品销售重量！");
        return false;
      }
      if (this.keyData.price == 0 && this.input_active_goods.goods_type == 1) {
        this.$toast("请输入商品单价！");
        return false;
      }
      if (this.input_active_goods.goods_type == 2 && this.input_active_goods.type == 1 && !(this.keyData.num > 0)) {
        this.$toast("请输入附加费数量！");
        return false;
      }
      let i = this.input_active_order_index,
        i_g = this.input_active_goods_index;
      if (this.input_active_goods.bale == 1) {
        this.order_list[i].order_goods[i_g].weight = (
          Number(this.keyData.num) * Number(this.input_active_goods.bale_num)
        ).toFixed(3);
      } else {
        this.order_list[i].order_goods[i_g].weight = this.keyData.weight;
      }
      this.order_list[i].order_goods[i_g].num = this.keyData.num;
      // this.order_list[i].order_goods[i_g].bale_num = this.keyData.bale_num

      this.order_list[i].order_goods[i_g].price =
        good.price < 0 && this.keyData.price > 0
          ? -this.keyData.price
          : this.keyData.price;
      // this.order_list[i].order_goods[i_g].price = this.keyData.price;
      var t_price = 0;
      if (this.input_active_goods.goods_type == 1) {
        if (this.input_active_goods.bale == 1) {
          t_price = (
            this.order_list[i].order_goods[i_g].price *
            this.order_list[i].order_goods[i_g].num
          ).toFixed(2);
        } else {
          t_price = (
            this.order_list[i].order_goods[i_g].price *
            this.order_list[i].order_goods[i_g].weight
          ).toFixed(2);
        }
      } else {
        if (this.input_active_goods.type == 1) {
          t_price = (
            this.order_list[i].order_goods[i_g].price *
            this.order_list[i].order_goods[i_g].num
          ).toFixed(2);
        } else {
          t_price = (this.order_list[i].order_goods[i_g].price * 1).toFixed(2);
        }
      }
      new Audio(
        "http://tts.baidu.com/text2audio?cuid=baiduid&lan=zh&ctp=1&pdt=311&tex=" +
          this.input_active_goods.name +
          "，" +
          t_price +
          "元"
      ).play();
      this.computeTotal();
      this.saveOrderGoods(i);
      this.showGoodsNum = false;
    },
    // 关闭事件
    keyOnClose() {
      this.keyData = {
        weight: "",
        num: "",
        price: ""
      };
      this.resetKey = false;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == "home" || to.name == "homeStaff") {
      this.$navigation.off("back");
    }
    next(); //一定不要忘记写
  }
};
</script>

<style lang="less" scoped>
.openOrder_order {
  position: relative;
  .iRemark {
    margin: 0 0.3rem;
    width: 6.54rem;
    background: #fff;
    margin-bottom: 0.8rem;
    height: 0.9rem;
    padding: 0 0.15rem;
    color: #eea10b;
    font-size: 0.36rem;
    border-radius: 0.1rem;
    display: flex;
    align-items: center;
  }
  .mask {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    z-index: 100;
    background: rgba(0, 0, 0, 0.5);
    .content {
      width: 6rem;
      height: 3rem;
      background: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -1.5rem;
      margin-left: -3rem;
      border-radius: 0.1rem;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      .toBox {
        margin-top: 0.8rem;
        margin-bottom: 0.8rem;
        display: flex;
        span {
          margin-right: 0.1rem;
          font-size: 0.32rem;
          font-weight: 400;
          color: #000;
          display: block;
          line-height: 0.6rem;
          height: 0.6rem;
        }
        input {
          width: 4.4rem;
          height: 0.6rem;
          border: 0.01rem solid #f2f2f2;
          padding: 0 0.1rem;
          border-radius: 0.08rem;
          font-size: 0.28rem;
        }
      }
      .maskConfirm {
        display: flex;
        justify-content: space-around;
        width: 100%;

        button {
          width: 50%;
          // width: 2rem;
          height: 1rem;
          background: #fff;
          border: none;
          outline: none;
          border: 0.01rem solid #f2f2f2;
          font-size: 0.4rem;
        }
        > button:nth-of-type(1) {
          color: #000;
          border-bottom-left-radius: 0.1rem;
        }
        > button:nth-of-type(2) {
          color: #31b158;
          border-bottom-right-radius: 0.1rem;
        }
      }
    }
  }
  // 键盘
  .good_num_box {
    position: relative;
    background-color: #f2f3f5;
    .good_title_box {
      font-size: 0.36rem;
      line-height: 0.6rem;
      padding: 0.2rem 0.5rem;
      color: #333;
      font-weight: bold;
      position: relative;
      span {
        font-size: 0.28rem;
        color: #999;
        font-weight: normal;
        margin-left: 0.2rem;
      }
      .good_box_close {
        position: absolute;
        right: 0.3rem;
        top: 0.2rem;
        z-index: 2;
      }
    }
    .good_content_box {
      padding: 0 0.3rem 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      .good_item_wn {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
      }
      .good_item_input_box {
        width: 100%;
        height: 0.88rem;
        line-height: 0.84rem;
        border: 0.02rem solid #ccc;
        padding: 0 0.15rem;
        margin-bottom: 0.2rem;
        box-sizing: border-box;
        border-radius: 0.1rem;
        .good_item_input {
          flex: auto;
          overflow: hidden;
          height: 0.84rem;
          margin: 0 0.1rem;
          padding-right: 0.05rem;
          position: relative;
          text-align: right;
          font-size: 0.32rem;
          font-weight: bold;
          background-color: transparent;
        }
      }
    }
  }
  .fake_div {
    position: relative;
    .fake_confim {
      position: absolute;
      right: 6px;
      z-index: 999;
      bottom: 6px;
      width: calc((100% - 6px) / 4 - 6px);
      height: calc(50% - 12px);
      background-color: #31b158;
      border-radius: 8px;
      button {
        background-color: #31b158;
        color: #fff;
        font-size: 0.42rem;
      }
    }
  }
  
  .backBox {
    display: flex;
    align-items: center;
    .tBack {
     width: 0.4rem;
      padding: 0 0.2rem;
      position: fixed;
      left: 0.02rem;
      top:0.3rem;
      z-index: 100;
    }
  }
  // 键盘结束

  .order_add_box {
    position: fixed;
    height: 0.88rem;
    // line-height: 0.88rem;
    text-align: center;
    right: 0.3rem;
    top: 0;
    z-index: 10;
    font-size: 0.3rem;
    font-weight: 500;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: space-between;
    & > div {
      padding: 0 0.2rem;
      line-height: 0.54rem;
      border: 0.01rem solid #31b158;
      border-radius: 0.28rem;
      background-color: #31b158;
      color: #fff;
    }
  }
  .order_list {
    position: sticky;
    z-index: 2;
    top: 0.88rem;
    width: 100%;
    height: 1.72rem;
    padding-top: 0.52rem;
    // background: linear-gradient(-90deg, #25a94d, #3fbe66);
    background: url(./../../../assets/img/layout/home/bg.png) no-repeat center
      bottom;
    background-size: 100%;
    box-sizing: border-box;
    overflow: hidden;
    .order_items {
      width: 5.6rem;
      height: 1rem;
      white-space: nowrap;
      overflow-y: hidden;
      overflow-x: auto;
      &::before {
        content: ".";
        display: block;
        height: 0;
        visibility: hidden;
      }
      .order_item {
        line-height: 1rem;
        margin-right: 0.16rem;
        &:nth-child(1) {
          margin-left: 0.3rem;
        }
      }
    }
  }

  // 中间模块
  .shop_box {
    padding: 0.3rem 0.2rem 0;
    .shop_good {
      width: 6.9rem;
      margin: 0 auto 0.2rem;
      height: 1.5rem;
      border-radius: 0.1rem;
      background-color: #fff;
      border: 0.02rem solid #fff;
      overflow: hidden;
      position: relative;
      padding: 0 0.3rem;
      box-sizing: border-box;
      &.checked {
        border: 0.02rem solid #31b158;
        .shop_good_close {
          display: flex;
        }
      }
      .shop_good_name_price,
      .shop_good_type_num {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .shop_good_name_price {
        font-size: 0.36rem;
        color: #333;
        font-weight: bold;
        margin-top: 0.24rem;
      }
      .shop_good_type_num {
        font-size: 0.28rem;
        color: #666;
        margin-top: 0.12rem;
        .good_type {
          padding: 0 0.18rem;
          height: 0.4rem;
          line-height: 0.4rem;
          border-radius: 0.2rem;
          &.good_type_0 {
            background-color: #dafbdb;
            color: #4b9c64;
          }
          &.good_type_1 {
            background-color: #daeffb;
            color: #1d78c5;
          }
          &.good_type_2 {
            background-color: #fbedda;
            color: #bf8535;
          }
          &.good_type_3 {
            background-color: #fbe1da;
            color: #bf1535;
          }
          img {
            width: 0.22rem;
            height: 0.22rem;
            margin-left: 0.1rem;
          }
        }
      }

      .shop_good_close {
        position: absolute;
        right: 0;
        top: 0;
        width: 0.28rem;
        height: 0.28rem;
        background-color: #31b158;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        display: none;
      }
    }
  }
  // 添加货品
  .add_shop_good {
    width: 6.9rem;
    margin: 0 auto 0.2rem;
    height: 1.5rem;
    border-radius: 0.1rem;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.36rem;
    color: #31b158;
    font-weight: bold;
  }

  // 删除订单
  .romove_shop {
    background-color: #fb8a8a;
    width: 6.9rem;
    border-radius: 0.1rem;
    height: 0.8rem;
    margin: 0 auto 0.2rem;
    margin-top: 0.6rem;
    font-size: 0.36rem;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  // 底部
  .order_footer {
    width: 100%;
    height: 1.4rem;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0rem -0.1rem 0.2rem 0.05rem rgba(191, 191, 191, 0.1);
    .operation {
      display: flex;
      .remark {
        width: 1.6rem;
        height: 0.8rem;
        border: 0.01rem solid #eea10b;
        color: #eea10b;
        font-size: 0.4rem;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.08rem;
        margin-right: 0.1rem;
      }
      .toConfirm {
        width: 1.6rem;
        height: 0.8rem;
        background: #31b158;
        border-radius: 0.08rem;
        color: #fff;
        font-size: 0.4rem;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 0.1rem;
      }
    }

    &[disabled] {
      & > div:nth-child(1) {
        & > span {
          color: #b3b3b3 !important;
          .color_theme {
            color: #b3b3b3 !important;
          }
        }
      }
      // & > div:nth-child(2) {
      //   background-color: #b3b3b3;
      // }
    }
    & > div:nth-child(1) {
      & > span {
        display: block;
        margin-left: 0.5rem;
        font-size: 0.36rem;
        color: #333;
        font-weight: bold;
        &:nth-child(2) {
          margin-top: 0.1rem;
          font-size: 0.28rem;
        }
        .color_theme {
          color: #31b158;
          font-size: 0.36rem;
        }
      }
    }
  }
}
</style>

<style lang="less">
.openOrder_order {
  .van-tabs {
    width: 100%;
    // padding-right: 1.9rem ;
    height: 1.2rem;
    .van-tabs__wrap {
      height: 1.2rem;
      // line-height: 1rem;
      .van-tabs__nav {
        box-sizing: border-box;
        .van-tab {
          box-sizing: border-box;
          width: 1.6rem;
          min-width: 1.6rem;
          height: 1.2rem;
          background: rgba(255, 255, 255, 0.3);
          border-radius: 0.1rem 0.1rem 0px 0px;
          font-size: 0.32rem;
          color: #fff;
          padding: 0 0.1rem;
          // line-height: 1rem;
          margin-right: 0.2rem;
          flex: inherit;
          &:nth-child(1) {
            margin-left: 0.2rem;
          }
          .order_num {
            font-size: 0.28rem;
            line-height: 0.38rem;
          }
          .order_name {
            font-weight: bold;
            letter-spacing: -0.01rem;
          }
          &--active {
            background: #f5f5f5;
            color: #333;
            .order_num {
              color: #999999;
            }
          }
        }
      }
    }
    .van-tab:last-child {
      font-size: 0.6rem;
      margin-right: 1rem;
    }
  }
}
</style>